var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "border-work" }, [
    _c("div", { staticClass: "left" }, [
      _c("img", {
        staticClass: "img-technician",
        attrs: { src: "/static/img/acCleaning/svg/technician.svg" }
      }),
      _vm._v(" "),
      _c("div", [
        _c("h4", { attrs: { "data-aos": "fade-left" } }, [
          _vm._v(_vm._s(_vm.$t("ac_cleaning.apply_for_work_section.title")))
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "sub-text", attrs: { "data-aos": "fade-right" } },
          [
            _vm._v(
              _vm._s(_vm.$t("ac_cleaning.apply_for_work_section.subtitle"))
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", {}, [
      _c(
        "a",
        {
          staticClass: "button py-4",
          attrs: {
            href: _vm.socialContacts.professionalLineUrl,
            target: "_blank"
          }
        },
        [
          _c("img", {
            staticClass: "img-line",
            attrs: { src: "/static/img/acCleaning/svg/line-logo.svg" }
          }),
          _vm._v(" "),
          _c("p", { staticStyle: { color: "#009A54" } }, [
            _vm._v(
              _vm._s(_vm.$t("ac_cleaning.apply_for_work_section.line_contact"))
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31c1e0e6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c1e0e6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acCleaningRe/ApplyForWork.vue
// module id = 1600
// module chunks = 0